// extracted by mini-css-extract-plugin
export default {"wrap":"vI-z","fullWidth":"wI-z","hideOnDesktop":"xI-z","content":"yI-z","hasOpenedNav":"zI-z","crumbsList":"AI-z","dropdownsWrap":"BI-z"};